<div class="amadeus-direct-style">
  <div class="business-content profile-wrap">
    <ng-container *ngIf="agencyState$ | async as agency">
      <ng-container *ngIf="agency.isLoading">
        <spinner fixed="true"></spinner>
      </ng-container>

      <ng-container *ngIf="!agency.isLoading">
        <div class="row">
          <div class="mb-7 col-sm-4 col-12">
            <label for="name"
                   class="form-label"
                   i18n="@@agency-page.agencyFormName">Agency name</label>
            <input id="name"
                   type="text"
                   name="name"
                   class="form-control"
                   value="{{ agency.name }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="officeId"
                   class="form-label"
                   i18n="@@agency-page.agencyFormAmadeusOfficeId">Amadeus Office ID</label>
            <input type="text"
                   id="officeId"
                   name="officeId"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.office_code }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="pin"
                   class="form-label"
                   i18n="@@agency-page.agencyFormCtiPin">CTI Pin</label>
            <input id="pin"
                   type="text"
                   name="pin"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.primary_pin }}"
                   disabled />
          </div>
        </div>
        <div class="divider"></div>
        <div class="row">
          <div class="mb-7 col-sm-4 col-12">
            <label for="email"
                   class="form-label"
                   i18n="@@agency-page.agencyFormMainEMail">Main e-mail</label>
            <input id="email"
                   type="text"
                   name="name"
                   class="form-control"
                   value="{{ agency.email }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="phoneNumber"
                   class="form-label"
                   i18n="@@agency-page.agencyFormMainPhoneNumber">Main phone number</label>
            <input type="text"
                   id="phoneNumber"
                   name="officeId"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.phone_number }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="faxNumber"
                   class="form-label"
                   i18n="@@agency-page.agencyFormMainFaxNumber">Main fax number</label>
            <input id="faxNumber"
                   type="text"
                   name="pin"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.fax_number }}"
                   disabled />
          </div>
        </div>
        <div class="divider"></div>
        <div class="row">
          <div class="mb-7 col-sm-4 col-12">
            <label for="street"
                   class="form-label"
                   i18n="@@agency-page.profileFormAddress">Address</label>
            <input id="street"
                   type="text"
                   name="name"
                   class="form-control"
                   value="{{ agency.street }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="city"
                   class="form-label"
                   i18n="@@agency-page.agencyFormCity">City</label>
            <input type="text"
                   id="city"
                   name="officeId"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.city }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="postalCode"
                   class="form-label"
                   i18n="@@agency-page.agencyFormPostalCode">Postal Code</label>
            <input id="postalCode"
                   type="text"
                   name="pin"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.postal_code }}"
                   disabled />
          </div>
          <div class="mb-7 col-sm-4 col-12">
            <label for="country"
                   class="form-label"
                   i18n="@@agency-page.agencyFormCountry">Country</label>
            <input id="country"
                   type="text"
                   name="pin"
                   class="form-control"
                   autocomplete="off"
                   value="{{ agency.country }}"
                   disabled />
          </div>
        </div>
        <div class="border-top border-bottom border-primary p-5 mt-7">
          <div class="info-block__text">
            <span class="fa-circle-info fa-solid me-3 text-secondary"></span>
            {{infoBlockString}}
            <a class="link"
               href=""
               [routerLink]="['/contact/']">
              {{linkString}}</a>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
